import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { MarketApi } from './market';

// Paths mirror apps/api/admin/src/routes/{auctions,market}.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const marketHttp: MarketApi = {
  listAuctions: (q, o) => http.get('api', '/auctions', { ...rd(o), query: { ...q } }),
  getAuction: (id, o) => http.get('api', `/auctions/${seg(id)}`, rd(o)),
  createAuction: (req, o) => http.post('api', '/auctions', req, wr(o)),
  scheduleDrop: (req, o) => http.post('api', '/auctions/drops', req, wr(o)),
  cancelAuction: (id, req, o) => http.post('api', `/auctions/${seg(id)}/cancel`, req, wr(o)),
  overrideAuction: (id, req, o) => http.post('api', `/auctions/${seg(id)}/override`, req, wr(o)),
  listBackorders: (q, o) => http.get('api', '/auctions/backorders', { ...rd(o), query: { ...q } }),
  getBackorder: (id, o) => http.get('api', `/auctions/backorders/${seg(id)}`, rd(o)),
  listDrops: (q, o) => http.get('api', '/auctions/drops', { ...rd(o), query: { ...q } }),
  getDrop: (id, o) => http.get('api', `/auctions/drops/${seg(id)}`, rd(o)),
  listEscrowDeposits: (q, o) => http.get('api', '/rde/deposits', { ...rd(o), query: { ...q } }),
  getEscrowDeposit: (id, o) => http.get('api', `/rde/deposits/${seg(id)}`, rd(o)),
  listLegalLocks: (q, o) => http.get('api', '/legal-locks', { ...rd(o), query: { ...q } }),
  getLegalLock: (id, o) => http.get('api', `/legal-locks/${seg(id)}`, rd(o)),
  getCaseInbox: (q, o) => http.get('api', '/cases/inbox', { ...rd(o), query: { ...q } }),
  getVnnicCorrections: (o) => http.get('api', '/vnnic/corrections', rd(o)),
  getRdapOverview: (o) => http.get('api', '/rdap/overview', rd(o)),
  previewRdap: (domain, o) => http.get('api', '/rdap/preview', { ...rd(o), query: { domain } }),
};
